/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogAddressNftPortfolioListRequest = {
    page?: number;
    size?: number;
    address: string;
    tokenType?: ZerogAddressNftPortfolioListRequest.tokenType;
};

export namespace ZerogAddressNftPortfolioListRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

